import u from "mitt";
const m = {
  click: [() => null]
}, E = u(), L = (n) => {
  E.emit(n.action, n);
}, A = ({
  context: n,
  listeners: i
}) => {
  const o = Object.entries(i).reduce(
    (c, [t, r]) => {
      const e = c[t] || [];
      return {
        ...c,
        [t]: Array.isArray(r) ? [...e, ...r] : [...e, r]
      };
    },
    m
  );
  return Object.entries(o).reduce(
    (c, [t, r]) => ({
      ...c,
      [t]: (e) => {
        r?.forEach((s) => s(e)), L({
          action: t,
          context: n,
          event: e
        });
      }
    }),
    {}
  );
};
export {
  m as DEFAULT_LISTENERS,
  E as emitter,
  L as track,
  A as trackListeners
};
